import { css } from 'styled-components';
export const FontSize = {
  SIZE_10: 10,
  SIZE_12: 12,
  SIZE_14: 14,
  SIZE_16: 16,
  SIZE_18: 18,
  SIZE_20: 20,
  SIZE_24: 24,
  SIZE_26: 26,
  SIZE_32: 32,
  SIZE_36: 36,
  SIZE_40: 40,
  SIZE_48: 48,
  SIZE_64: 64,
  SIZE_68: 68
};
export const FontWeight = {
  BOLD: 'bold',
  NORMAL: 'normal',
  WEIGHT_100: 100,
  WEIGHT_300: 300,
  WEIGHT_400: 400,
  WEIGHT_500: 500,
  WEIGHT_600: 600,
  WEIGHT_700: 700,
  WEIGHT_800: 800,
  WEIGHT_900: 900
};
export const BASE_TYPOGRAPHY_STYLES = () => css(["margin:0;transition:color 0.3s;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-tap-highlight-color:transparent;"]);
export const TextAlign = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
  JUSTIFY: 'justify'
};
export const LineHeight = {
  UNSET: 'unset',
  INHERIT: 'inherit',
  INITIAL: 'initial',
  REVERT: 'revert',
  NORMAL: 'normal',
  HEIGHT_16: 16,
  HEIGHT_18: 18,
  HEIGHT_20: 20,
  HEIGHT_22: 22,
  HEIGHT_24: 24,
  HEIGHT_32: 32,
  HEIGHT_48: 48
};
export const HTML_TAG_TO_TYPOGRAPHY_TYPE = {
  h1: 'h1 heading',
  h2: 'h2 heading',
  h3: 'h3 heading',
  h4: 'h4 heading',
  h5: 'h5 heading',
  button: 'cta button',
  a: 'hyperlink',
  p: 'text body',
  small: 'text small',
  i: 'overline'
};
export const TypographyType = {
  H1: 'h1',
  H1_LARGE: 'h1_large',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  BODY: 'body',
  BODY2: 'body2',
  SMALL: 'small',
  OVERLINE: 'overline',
  CTA_BUTTON: 'cta_button'
};
export const TextTags = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  DIV: 'div',
  SMALL: 'small',
  P: 'p',
  SPAN: 'span',
  LABEL: 'label'
};
export const TYPOGRAPHY_TYPE_TO_HTML_TAG = {
  [TypographyType.H1]: 'h1',
  [TypographyType.H1_LARGE]: 'h1',
  [TypographyType.H2]: 'h2',
  [TypographyType.H3]: 'h3',
  [TypographyType.H4]: 'h4',
  [TypographyType.H5]: 'h5',
  [TypographyType.BODY]: 'p',
  [TypographyType.BODY2]: 'p',
  [TypographyType.SMALL]: 'p',
  [TypographyType.OVERLINE]: 'p',
  [TypographyType.CTA_BUTTON]: 'span'
};
export const TypographyTypeOrTag = {
  ...TypographyType,
  ...TextTags
};
export const ALLOWED_TAGS = Object.values(TextTags);
export const TextTransform = {
  NONE: 'none',
  LOWER_CASE: 'lowercase',
  UPPER_CASE: 'uppercase'
};
export const FontColor = {
  MONO_900: 'mono_900',
  MONO_600: 'mono_600',
  MONO_500: 'mono_500',
  MONO_100: 'mono_100',
  DARK: 'dark',
  LIGHT: 'light',
  POSITIVE_CONTRAST: 'positive_contrast',
  NEGATIVE_CONTRAST: 'negative_contrast',
  ATTENTION_CONTRAST: 'attention_contrast'
};